import React, { ReactElement } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useJoinUrl } from '../components/buttons/JoinButton';
import { useSelector } from 'src/client/redux';
import { UNAUTHORIZED_ROUTE } from 'src/client/constants/joinCampaigns';

type Props = {
  campaign?: string;
  exact?: boolean;
  path: string | string[];
} & (
  | {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      component: ReactElement | React.LazyExoticComponent<any> | React.FC;
      render?: never;
    }
  | {
      render: Function;
      component?: never;
    }
);

export const PrivateRoute = (props: Props) => {
  const { campaign = UNAUTHORIZED_ROUTE, render, component, ...rest } = props;
  const Component = component as React.ElementType;

  const { user, loaded: userLoaded } = useSelector((state) => state.auth);
  const [joinUrl] = useJoinUrl({ campaign });

  if (!userLoaded) {
    return null;
  }

  const isUser = !!user;

  return (
    <Route
      {...rest}
      render={(routeProps) => {
        if (!userLoaded) return null;

        if (isUser) {
          return Component ? <Component {...routeProps} /> : render && render(routeProps);
        }

        return <Redirect to={joinUrl} />;
      }}
    />
  );
};
